import { config as commonConfig } from '@waitroom/config';
import type { FeatureFlags } from '@waitroom/models';
import { parseJson, toBoolean } from '@waitroom/utils';
import { envs } from '../services/envs';
import { updateDebugSettings, useAppStore } from '../store/store';
import type { Environment } from '../types';
const generalSettings = useAppStore.getState();

export const version = envs.__APP_VERSION__;
const env = (envs.NODE_ENV || 'production') as Environment;
const customEnv = (envs.VITE_ENVIRONMENT || env) as Environment;

export { commonConfig };

export const environments = {
  env,
  customEnv: customEnv,
  isProd: customEnv === 'production',
  isDev: customEnv === 'development',
  isStaging: customEnv === 'staging',
};

export const isMaintenance = toBoolean(envs.VITE_MAINTENANCE);

export const featureFlags = parseJson<FeatureFlags>(envs.VITE_FEATURE_FLAGS || '{}') || {};

let _baseUrl = envs.VITE_BASE_URL || window.location.origin;
// patch amplify preview web app
if (envs.VITE_BASE_URL === 'AMPLIFY_PREVIEW') {
  _baseUrl = `https://pr-${envs.AWS_PULL_REQUEST_ID}.${envs.AWS_APP_ID}.amplifyapp.com`;
}
export const BASE_URL = _baseUrl;
export const DOMAIN_URL = window.location.hostname;

const protocol = toBoolean(envs.VITE_IS_LOCAL) ? 'http' : 'https';
export const WORMHOLE_ENV_URL = String(`${protocol}://${envs.VITE_WORMHOLE_DOMAIN}`);
export const LUXOR_URL = String(`${protocol}://${envs.VITE_LUXOR_DOMAIN}`);
export const WORMHOLE_URL = environments.isProd
  ? WORMHOLE_ENV_URL
  : generalSettings.debug?.previewEndpoint || WORMHOLE_ENV_URL;
export const CDN_URL = envs.VITE_CDN_DOMAIN as string;
export const CDN_IMAGES_URL = `${CDN_URL}/images`;
export const CDN_VIDEOS_URL = `${CDN_URL}/videos`;
export const CDN_LOGO_URL = `${CDN_URL}/images/logo`;

export const metaData = {
  imageURL: `${CDN_IMAGES_URL}/meta/og-image.jpg`,
};

export const APP_URL_ORIGIN = envs.VITE_APP_URL_ORIGIN as string;

// Because the preview endpoint can go offline when the branch is closed, we should check that it does not return 500
// and if it does, we should fallback to the default wormhole endpoint
const checkPRurl = () => {
  const url = generalSettings.debug?.previewEndpoint;
  if (!!url) {
    fetch(url).catch((e) => {
      updateDebugSettings({
        previewEndpoint: undefined,
      });
      window.location.reload();
    });
  }
};
if (!environments.isProd) checkPRurl();
